'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var pull = require('pull-stream');

var lp = require('pull-length-prefixed');

var handshake = require('pull-handshake');

var debug = require('debug');

var log = debug('libp2p:circuit:stream-handler');
log.err = debug('libp2p:circuit:error:stream-handler');

var StreamHandler =
/*#__PURE__*/
function () {
  /**
   * Create a stream handler for connection
   *
   * @param {Connection} conn - connection to read/write
   * @param {Function|undefined} cb - handshake callback called on error
   * @param {Number} timeout - handshake timeout
   * @param {Number} maxLength - max bytes length of message
   */
  function StreamHandler(conn, cb, timeout, maxLength) {
    _classCallCheck(this, StreamHandler);

    this.conn = conn;
    this.stream = null;
    this.shake = null;
    this.timeout = cb || 1000 * 60;
    this.maxLength = maxLength || 4096;

    if (typeof cb === 'function') {
      this.timeout = timeout || 1000 * 60;
    }

    this.stream = handshake({
      timeout: this.timeout
    }, cb);
    this.shake = this.stream.handshake;
    pull(this.stream, conn, this.stream);
  }

  _createClass(StreamHandler, [{
    key: "isValid",
    value: function isValid() {
      return this.conn && this.shake && this.stream;
    }
    /**
     * Read and decode message
     *
     * @param {Function} cb
     * @returns {void|Function}
     */

  }, {
    key: "read",
    value: function read(cb) {
      if (!this.isValid()) {
        cb(new Error("handler is not in a valid state"));
      }

      lp.decodeFromReader(this.shake, {
        maxLength: this.maxLength
      }, function (err, msg) {
        if (err) {
          log.err(err); // this.shake.abort(err)

          return cb(err);
        }

        return cb(null, msg);
      });
    }
    /**
     * Encode and write array of buffers
     *
     * @param {Buffer[]} msg
     * @param {Function} [cb]
     * @returns {Function}
     */

  }, {
    key: "write",
    value: function write(msg, cb) {
      var _this = this;

      cb = cb || function () {};

      if (!this.isValid()) {
        cb(new Error("handler is not in a valid state"));
      }

      pull(pull.values([msg]), lp.encode(), pull.collect(function (err, encoded) {
        if (err) {
          log.err(err);

          _this.shake.abort(err);

          return cb(err);
        }

        encoded.forEach(function (e) {
          return _this.shake.write(e);
        });
        cb();
      }));
    }
    /**
     * Get the raw Connection
     *
     * @returns {null|Connection|*}
     */

  }, {
    key: "getRawConn",
    value: function getRawConn() {
      return this.conn;
    }
    /**
     * Return the handshake rest stream and invalidate handler
     *
     * @return {*|{source, sink}}
     */

  }, {
    key: "rest",
    value: function rest() {
      var rest = this.shake.rest();
      this.conn = null;
      this.stream = null;
      this.shake = null;
      return rest;
    }
    /**
     * Close the stream
     *
     * @returns {undefined}
     */

  }, {
    key: "close",
    value: function close() {
      // close stream
      pull(pull.empty(), this.rest());
    }
  }]);

  return StreamHandler;
}();

module.exports = StreamHandler;